import React from 'react';

const Header = () => {
    return (
        <header
            style={{
                backgroundColor: '#4CAF50',
                color: 'white',
                padding: '10px 20px',
                textAlign: 'center',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            }}
        >
            <h1 style={{ margin: 0 }}>
                JSON Tools Suite{' '}
                <span
                    style={{
                        fontSize: '16px',
                        backgroundColor: 'orange',
                        color: 'white',
                        padding: '2px 8px',
                        borderRadius: '5px',
                        marginLeft: '10px',
                    }}
                >
                    Beta
                </span>
            </h1>
            <p style={{ margin: 0, fontSize: '14px' }}>
                Built with <span style={{ color: 'red' }}>❤️</span> by{' '}
                <a
                    href="https://ca.linkedin.com/in/nitendra-s-58324453?trk=people-guest_people_search-card"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        color: 'white',
                        textDecoration: 'underline',
                        fontWeight: 'bold',
                    }}
                >
                    Nitendra Shukla
                </a>{' '}
                |{' '}
                <a
                    href="https://sfdc247.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        color: 'white',
                        textDecoration: 'underline',
                        fontWeight: 'bold',
                    }}
                >
                    SFDC247
                </a>
            </p>
        </header>
    );
};

export default Header;